<template>
  <div class="login">
    <div class="login-form content-padding row">
      <form @submit.prevent.stop="submitLoginForm">
        <h2>Вход в личный кабинет</h2>
        <div>
          <label for="username" class="form-label">E-mail</label>
          <input v-model="user.username" type="text" class="form-control" :class="{'is-invalid': incorrectData}"
                 id="username">
          <div v-if="incorrectData" class="invalid-feedback">
            Неверный логин или пароль
          </div>
        </div>
        <div>
          <label for="password" class="form-label">Пароль</label>
          <div class="input-with-button">
            <input v-model="user.password" :type="showPass ? 'text' : 'password'" class="form-control"
                   :class="{'is-invalid': incorrectData}" id="password">
            <span @click="showPass = !showPass" :class="showPass ? 'ic-eye' : 'ic-eye-cross'"></span>
          </div>

        </div>
        <button type="submit" class="btn btn-primary">Войти</button>
      </form>

    </div>
  </div>
  <div class="additional-link">
    <a href="/static-frontend/stoimost.png" target="_blank">Стоимость доступа</a>
  </div>
  <div class="additional-link">
    <a href="/static-frontend/files/technical-requirements.pdf" target="_blank">Технические требования</a>
  </div>
  <div class="additional-link">
    <a href="/static-frontend/files/user-manual.pdf" target="_blank">Инструкция пользователя</a>
  </div>
  <div class="additional-link">
    <a href="/static-frontend/files/about.pdf" target="_blank">О проекте</a>
  </div>
</template>

<script>
import useLogin from "@/composables/UseLogin";
import router from "@/router";

export default {
  name: 'Login',
  setup() {
    const login = useLogin()
    if (login.isAuthorized.value) {
      router.push('/')
    }
    return {
      ...login
    }
  },
  data() {
    return {
      user: {
        username: undefined,
        password: undefined,
      },
      incorrectData: false,
      showPass: false
    }
  },
  methods: {
    submitLoginForm() {
      this.login(this.user)
        .catch(() => this.incorrectData = true)
    }
  },
  watch: {
    user: {
      handler() {
        this.incorrectData = false
      },
      deep: true
    },
  }

}
</script>

<style scoped lang="scss">

.login {
  width: 100%;
  display: flex;
  height: 450px;
  align-items: stretch;
  flex-direction: column;

  .login-registration {
    .login-link {
      margin: 0 1rem;
    }
  }

  h2 {
    margin: 2rem 0;
  }

  .login-form {
    height: 100%;

    form {
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: stretch;
      justify-content: space-between;
    }

    .login-password-label {
      display: flex;
      justify-content: space-between;
      padding: 0 .5rem;
    }

    .input-with-button {
      position: relative;

      input {
        padding-right: 55px;
      }

      span{
        cursor: pointer;
        position: absolute;
        right: 20px;
        top: calc(50% - 17px);
      }
    }

    button {
      align-self: flex-start;
    }

    input.form-control.is-invalid {
      background-image: none;
    }
  }
}

.additional-link {
  margin-left: 2rem;
  margin-bottom: 1rem;
}

@media (max-width: 400px) {
  .login {
    h2 {
      margin-top: 1em;
    }
    .login-form {
      button {
        margin-top: 0;
        width: 100%;
      }
    }
  }

}

</style>
